import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.clients.data.ContactContainerManager.';
  public static readonly newContact = `${Id.prefix}newContact`;
}

export class LangContactContainerManager {
  private constructor() {}
  public static newContact(): string {
    return interpolate(Id.newContact);
  }
}

export class ContactContainerManagerModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.newContact, "New {{glossary 'contact'}}", 'Default name for a new contact');
  }
}
